import { animate, style, transition, trigger } from '@angular/animations';

export const enterUnfold = trigger('enterUnfold', [
    transition(':enter', [
      style({
        height: 0
      }),
      animate(
        100,
        style({
          height: '*'
        })
      ),
    ]),
  ]);
